module.exports = __webpack_public_path__ + "static/media/1018106.6f6a78a8.png";